(function () {
  var iconsListDecoreAnimated = () => {

    gsap.to(".icons-list__decor .mim-logo", {
      scrollTrigger: {
        trigger: ".icons-list",
        start: "top bottom",
        end: "bottom -150%",
        scrub: 0.1,
      },
      y: 400,
    });

  };

  document.addEventListener('shopify:section:load', function () {
    iconsListDecoreAnimated();
  });

  setTimeout(() => {
    iconsListDecoreAnimated();
  }, 990);
})();
